<template>
  <a-modal
    :visible="visible"
    title="揉单排序"
    :confirm-loading="confirmCloseBtnLading"
    @ok="handleOk"
    @cancel="onClose"
  >
    <a-range-picker
      v-model="closeReason"
      valueFormat="YYYY-MM-DD"
      allowClear
    />
  </a-modal>
</template>

<script>
export default {
  name: 'CancelModal',
  data () {
    return {
      visible: false,
      confirmCloseBtnLading: false,
      closeReason: undefined
    }
  },
  methods: {
    show (data) {
      this.selectedRowKeys = data
      this.visible = true
      this.closeReason = undefined
    },
    // 驳回
    onClose () {
      this.visible = false;
      this.closeReason = undefined
    },
    // 取消
    handleOk () {

    }
  }
}
</script>

<style scoped>

</style>
